import { easings } from "@react-spring/web";

// HOST all our default animation config
export const DEFAULT_ANIMATION_CONFIG = {
  duration: 300 /** milliseconds */,
  // This is a function that receives a progress and returns stuff we have done to that progress
  // and we can use it with any serious animation library
  easing: easings.easeInOutSine,
} as const;
